<template>
  <div class="analysisTable">
      <div class="analysisTable__header">
          <div class="analysisTable__header--icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 14 14"><g fill="none" stroke="#44A561" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="5.5" r="2.5"/><path d="M2.73 11.9a5 5 0 0 1 8.54 0"/><circle cx="7" cy="7" r="6.5"/></g></svg>
          </div>
          <div class="analysisTable__header--title ml-3">Detalhes pessoais</div>
      </div>
      <div class="analysisTable__content" v-if="!isLoading">
          <div class="analysisTable__content--list">
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Idade</div>
                          <div class="item__container--value">{{ age }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Gênero</div>
                          <div class="item__container--value">{{ gender }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Data de nascimento</div>
                          <div class="item__container--value">{{ birthDate }}</div>
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Data de verificação de status da fiscalização</div>
                          <div class="item__container--value">{{ inspectionStatus }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">Estados em que atua</div>
                          <div class="item__container--value">{{ stateThatOperates }}</div>
                          
                      </div>
                  </div>
              </div>
              <div class="analysisTable__content--list-item no-border">
                  <div class="item">
                      <div class="item__container">
                          <div class="item__container--title">País de fiscalização</div>
                          <div class="item__container--value container-img">{{ countryOfInspection }} 
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 72 72"><path fill="#5c9e31" d="M5 17h62v38H5z"/><path fill="#fcea2b" d="m59.023 36.023l-23.157 14.63l-22.889-14.362l23.157-14.63z"/><circle cx="36" cy="36" r="9" fill="#1e50a0"/><path fill="#fff" d="M44.159 39.782a9 9 0 0 0 .696-2.26a11.474 11.474 0 0 0-17.477-4.04a9 9 0 0 0-.352 2.013a10.998 10.998 0 0 1 17.133 4.287"/><path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M5 17h62v38H5z"/></svg>
                          </div>
                          
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div v-else class="row justify-content-center p-5">
          <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
          </div>
      </div>
  </div>

</template>

<script>
export default {
  name: 'personalEnrichment',
  props: {
      data: {
          type: Object,
          required: true
      },
      count: {
          type: Object,
          required: false
      },
  },
  computed: {
      isLoading() {
        return this.$store.getters["getLoadingAnalysis"]
      },
      age() {
          return this.data && this.data.age ? this.data.age : '---';
      },
      gender() {
          return this.data && this.data.gender ? this.data.gender : '---';
      },
      birthDate() {
        if(this.data && this.data.birth_date){
            const date = new Date(this.data.birth_date);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return '---';
    },
      inspectionStatus() {      
        if(this.data && this.data.tax_id_status_date){
            const date = new Date(this.data.tax_id_status_date);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`
        }
        return '---';
      },
      stateThatOperates() {
          return this.data && this.data.tax_id_fiscal_region ? this.data.tax_id_fiscal_region : '---';
      },
      countryOfInspection() {
          return this.data && this.data.tax_id_country ? this.data.tax_id_country : '---';
      },
  },
};
</script>

<style scoped lang="scss">
.analysisTable {
  width: 100%;
  margin: 20px 0px 0px 0px;
  border: solid 1px #E5E5E5;
  border-radius: 10px ;
  padding-top: 15px;


  &__header {
      padding: 0px 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center; 
      gap: 10px;

      &--icon {
          flex-shrink: 0;
      }

      &--title {
          color: #44A561;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-left: 14px;
      }
  }

  &__content {
      height: auto;
      width: 100%;

      hr {
          background: #E5E5E5;
      }

      &--list {
          height: auto;
          width: 100%;
          margin: 20px 0px;

          .item {
              border-bottom: solid 1px #E5E5E5;
              position: relative;

              &__container {
                  padding: 20px;

                  &--title {
                      color: #B1B1B1;
                      font-size: 0.8em;
                      font-style: normal;
                      font-weight: 400;
                      line-height: normal;
                  }

                  &--value {
                      color: #141414;
                      font-size: 0.9em;
                      font-style: normal;
                      font-weight: 600;
                      line-height: normal;
                      width: calc(100% - 40px);
                      overflow-x: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                  }

                  &--pill {
                      position: absolute;
                      right: 20px;
                      top: 30%;
                      width: auto;
                      font-size: 0.7em;
                      padding: 4px 10px;
                      font-size: 12px;
                      font-style: normal;
                      font-weight: 600;
                      line-height: normal;
                      border-radius: 50px;


                  }
              }

          }

          .no-border .item {
                border-bottom: none;
            }

      }
  }
}

.container-img {
  display: flex;
  justify-content: space-between;
}

.item__container--value {
  svg {
    position: relative;
    top: -8px;
  }
}

.blue {
  background: rgba(54, 130, 243, 0.10);
  color: #3682F3;
}

.red {
  background: rgba(255, 95, 95, 0.10);
  color: #FF5F5F;
}
</style>